import { TitleFieldProps } from "@rjsf/utils";
import { Typography } from 'antd';
import React from 'react';
import { isRootId } from './ids';

const { Title } = Typography;

/**
 * The heading over an object. The alignment used to be set here, one inline
 * style per template, to undo the wizard's centred wrapper; the builder's root
 * does that once now (SubmissionBuilder.css).
 */
function TitleFieldTemplate(props: TitleFieldProps) {
    const { title, uiSchema, id, schema, registry } = props;

    // Extract the field name from the id (e.g., "sources" from "142_sources__title")
    const fieldMatch = id?.match(/\d+_(\w+)__/);
    const fieldName = fieldMatch?.[1];

    // Check if this field is a child of an anyOf by looking at the root schema
    const schemaProperty = fieldName ? registry.rootSchema.properties?.[fieldName] : undefined;
    const isAnyOfChild = fieldName && typeof schemaProperty === 'object' && 'anyOf' in schemaProperty;

    // Hide titles inside arrays (matches patterns like: xxx_0, xxx_0_yyy, or xxx-0)
    // Or hide titles for anyOf children
    // show title for anyOf root
    if (id && (/[_-]\d+(_|$)/.test(id) || isAnyOfChild) && !schema.anyOf) {
        return null;
    }

    /* The root object's title is the form's title; the rest are section
       headings. Told apart by the field path — the old test was whether the
       uiSchema was an empty object, which is equally true of every nested
       object nobody gave ui options to, so an `anyOf` four levels down was
       being set as the form's own heading. */
    const isRoot = isRootId(id);

    return (
        <Title level={isRoot ? 5 : 4} className={`sb-form-title${isRoot ? ' sb-form-title--root' : ''}`}>
            {title}
        </Title>
    );
}

export default TitleFieldTemplate;
